import { Tooltip, Typography } from "@mui/material";
import { EpisodicBadge } from "components/EpisodicBadge";
import { LineItemFragment } from "generated-graphql/graphql";
import { formatPounds } from "routes/Customer/Waste/EpisodicEvents/episodicDisplay";

type LineEpisodicExemptions = LineItemFragment["episodicExemptions"];

export function lineEpisodicBadgeTooltip(exemptions: LineEpisodicExemptions): string {
  const [only] = exemptions;
  const source =
    exemptions.length === 1 && only ? only.episodicEvent.reason : `${exemptions.length} events`;
  return `Episodic waste from ${source} is excluded from generator status`;
}

export function LineEpisodicBadge({ exemptions }: { exemptions: LineEpisodicExemptions }) {
  if (exemptions.length === 0) {
    return null;
  }
  return <EpisodicBadge density="compact" tooltip={lineEpisodicBadgeTooltip(exemptions)} />;
}

/** The grid column form: the excluded pounds, with the event named on hover. */
export function LineEpisodicCell({ exemptions }: { exemptions: LineEpisodicExemptions }) {
  if (exemptions.length === 0) {
    return null;
  }
  const pounds = exemptions.reduce((sum, exemption) => sum + exemption.pounds, 0);
  return (
    <Tooltip title={lineEpisodicBadgeTooltip(exemptions)}>
      <Typography variant="body2" component="span">
        {formatPounds(pounds)}
      </Typography>
    </Tooltip>
  );
}
